var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesRow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 18,
    viewBox: "0 0 528 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 417,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 451,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 519,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 417,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 451,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 519,
    cy: 9,
    r: 9,
    fill: "#F67280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesRow);
export default __webpack_public_path__ + "static/media/circles-row.10a1d01800f36eac81b8e427eb92a762.svg";
export { ForwardRef as ReactComponent };